import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const ProvidersListPage = lazy(() => import('./ProvidersListPage'));
const ProviderDetailPage = lazy(() => import('./ProviderDetailPage'));

export const providerRoutes: RouteObject[] = [
  {
    path: 'providers',
    element: (
      <ProtectedRoute action="providers:view">
        <ProvidersListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'providers/:id',
    element: (
      <ProtectedRoute action="providers:view">
        <ProviderDetailPage />
      </ProtectedRoute>
    ),
  },
];
